import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const PreviewModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title" dangerouslySetInnerHTML={{__html: t(`Preview`)}} />
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p dangerouslySetInnerHTML={{__html: t(`Add teaser text for your challenge. 
        This will appear in the challenge list before the player selects the challenge.`)}} />
        <p dangerouslySetInnerHTML={{__html: t(`Do not use HTML in your preview text. It should be plain text only.`)}} />
      </div>
      <div className="modal-footer">
        <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t(`Close`)}
        </Button>
      </div>
    </Modal>
  )
}

export default PreviewModal;
